module MainService {

    export interface IMainService {
        setJWT: (token: string, prop: {[key: string]: string}) => void;
        cleanJWT: () => void;
        geti18nLang: () => string;
        getUserTimezone: () => string;
        geti18nDefaultLang: () => string;
        reloadLang: () => void;
    }

    export class CMainService implements IMainService {

        constructor(
            protected $sessionStorage: any,
            protected $timeout: angular.ITimeoutService,
            protected $translate: angular.translate.ITranslateService,
            protected GlobalApplicationData: any,
            protected jwtHelper: any,
            protected $resource: ng.resource.IResourceService,
            protected $q: angular.IQService,
            protected ConfigService: any
        ) {

        }

        /** 
         * Salvo il token e il payload 
        */
        public setJWT = (token: string, prop: {[key: string]: string}): void => {

            console.log("set the jwt token:", token);

            this.GlobalApplicationData.propertyMap = prop;
            this.$sessionStorage.identityToken = token;
            this.$sessionStorage.propertyMap = prop;
            this.GlobalApplicationData.identityToken = token;
            this.GlobalApplicationData.jwtPayload = token ? this.jwtHelper.decodeToken(token) : null;


            this.reloadLang();
        }

        /**
         *  Elimino il token 
        */
        public cleanJWT = (): void => {
            this.$sessionStorage.identityToken = null;
            this.GlobalApplicationData.identityToken = null;
            this.GlobalApplicationData.jwtPayload = null;
            this.$sessionStorage.propertyMap = null;

            // TODO annullo rinnovo del token
        }

        /**
         * Lingua attualmente in uso recuperata dal Token
         */
        public geti18nLang = (): string => {
            return "it";
        }

        /**
         * Timezone attualmente in uso recuperata dal Token
         */
        public getUserTimezone = (): string => {
            return "Europe/Rome";
        }

        /**
         * La lingua di default
         */
        public geti18nDefaultLang = (): string => {
            for (var i = 0; i < this.GlobalApplicationData.langs.length; i++) {
                if (this.GlobalApplicationData.langs[i].mandatory) {
                    return this.GlobalApplicationData.langs[i].lang.substring(0, 2);
                }
            }
            return "it";
        }

        public reloadLang = (): void => {
            let langKey = this.geti18nLang();

            if (!langKey) {
                langKey = this.geti18nDefaultLang();
            }

            console.log("set lang key:", langKey);

            this.$translate.use(langKey);
        };
    }

    // registro la factory
    angular.module("CustPortalApp").factory("MainService", ($sessionStorage: any, $timeout: angular.ITimeoutService, $translate: angular.translate.ITranslateService, GlobalApplicationData: any, jwtHelper: any, $resource: ng.resource.IResourceService, $q: angular.IQService, ConfigService: any) => new MainService.CMainService($sessionStorage, $timeout, $translate, GlobalApplicationData, jwtHelper, $resource, $q, ConfigService));
}
